var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVersionsDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81292 2.83333H13.75C14.9466 2.83333 15.9166 3.80338 15.9166 4.99999V15C15.9166 16.1966 14.9466 17.1667 13.75 17.1667H6.24998C5.05336 17.1667 4.08331 16.1966 4.08331 15V7.40701L8.81292 2.83333ZM9.21735 3.83333L5.08331 7.83108V15C5.08331 15.6443 5.60565 16.1667 6.24998 16.1667H13.75C14.3943 16.1667 14.9166 15.6443 14.9166 15V4.99999C14.9166 4.35566 14.3943 3.83333 13.75 3.83333H9.21735Z",
    fill: "#667C99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01513 2.83333C9.29127 2.83333 9.51513 3.05719 9.51513 3.33333V5.95238C9.51513 7.14899 8.54508 8.11904 7.34846 8.11904H4.58331C4.30717 8.11904 4.08331 7.89519 4.08331 7.61904C4.08331 7.3429 4.30717 7.11904 4.58331 7.11904H7.34846C7.9928 7.11904 8.51513 6.59671 8.51513 5.95238V3.33333C8.51513 3.05719 8.73899 2.83333 9.01513 2.83333Z",
    fill: "#667C99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53058 10.4762C7.53058 10.2 7.75444 9.97617 8.03058 9.97617H11.97C12.2461 9.97617 12.47 10.2 12.47 10.4762C12.47 10.7523 12.2461 10.9762 11.97 10.9762H8.03058C7.75444 10.9762 7.53058 10.7523 7.53058 10.4762Z",
    fill: "#667C99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53058 12.7381C7.53058 12.462 7.75444 12.2381 8.03058 12.2381H11.97C12.2461 12.2381 12.47 12.462 12.47 12.7381C12.47 13.0142 12.2461 13.2381 11.97 13.2381H8.03058C7.75444 13.2381 7.53058 13.0142 7.53058 12.7381Z",
    fill: "#667C99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionsDisabled);
export default __webpack_public_path__ + "static/media/versions_disabled.ec6dfcd09a783fd69044dbd27f4221ab.svg";
export { ForwardRef as ReactComponent };